import { Injectable, inject } from '@angular/core';
import { DfEventService, IEventType } from '@df/core/service/df-event';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import { TimeoutService } from '@df/ng/timeout.service';
import './gtm-event-search';

@Injectable({
    providedIn: 'root'
})
export class GtmEventSearchTrigger {
    /**
     * GTM service
     */
    private gtmService = inject(GtmDlService);

    /**
     * Customer model service
     */
    private dfEventService = inject(DfEventService);

    /**
     * Timeout service
     */
    private timeoutService = inject(TimeoutService);

    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }

    /**
     * Setup listeners
     */
    private init() {
        this.dfEventService.success(event => {
            if (event.id === 'dfSearch') {
                if (event.data.autocomplete) {
                    this.dispatchQuickSearchDebounced(event);
                } else {
                    this.dispatchSearch(event);
                }
            }
        });
    }

    /**
     * Debounced quikc search
     */
    private dispatchQuickSearchDebounced = this.timeoutService.debounce(e => this.dispatchQuickSearch(e), 2000);

    /**
     * Dispatch event
     */
    private async dispatchSearch(searchEvent: IEventType['dfSearch']) {
        return this.gtmService.dispatch({
            event: 'search',
            search_term: searchEvent.data.q,
            search_type: 'search',
            triggerContext: { trigger: searchEvent }
        });
    }

    /**
     * Quick search event
     */
    private async dispatchQuickSearch(searchEvent: IEventType['dfSearch']) {
        return this.gtmService.dispatch({
            event: 'search',
            search_term: searchEvent.data.q,
            search_type: 'quicksearch',
            triggerContext: { trigger: searchEvent }
        });
    }
}
